import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/LogoTriM.png'


const _withScopeId = n => (_pushScopeId("data-v-b7a23f08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar navbar-expand-lg navbar-light bg-light" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "/"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Logo",
    width: "90",
    class: "d-inline-block align-text-top"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarTogglerDemo03",
  "aria-controls": "navbarTogglerDemo03",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1))
const _hoisted_5 = {
  class: "collapse navbar-collapse",
  id: "navbarTogglerDemo03"
}
const _hoisted_6 = { class: "flex-grow-1 d-flex" }
const _hoisted_7 = {
  class: "modal fade",
  id: "searchModal",
  tabindex: "-1",
  "aria-labelledby": "searchModalLabel",
  "aria-hidden": "true"
}
const _hoisted_8 = { class: "modal-dialog" }
const _hoisted_9 = { class: "modal-content" }
const _hoisted_10 = { class: "modal-header" }
const _hoisted_11 = { class: "modal-title" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  id: "searchModalClose",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_13 = { class: "modal-body" }
const _hoisted_14 = { class: "d-flex" }
const _hoisted_15 = { class: "nav-item dropdown nav-justified" }
const _hoisted_16 = {
  class: "btn btn-outline-secondary dropdown-toggle w-100",
  type: "button",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_17 = { class: "dropdown-menu dropdown-content" }
const _hoisted_18 = {
  key: 0,
  class: "opacity-50"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  "data-bs-toggle": "modal",
  "data-bs-target": "#reportModal",
  class: "dropdown-item opacity-75",
  type: "button"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "opacity-50" }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1))
const _hoisted_24 = {
  class: "modal fade",
  id: "reportModal",
  tabindex: "-1",
  "aria-labelledby": "reportModalLabel",
  "aria-hidden": "true"
}
const _hoisted_25 = { class: "modal-dialog" }
const _hoisted_26 = { class: "modal-content" }
const _hoisted_27 = { class: "modal-header" }
const _hoisted_28 = { class: "modal-title" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  id: "reportModalClose",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_30 = { class: "modal-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datepicker = _resolveComponent("Datepicker")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Search, {
            "data-bs-toggle": "modal",
            "data-bs-target": "#searchModal",
            placeholder: _ctx.$t.search
          }, null, 8, ["placeholder"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("h5", _hoisted_11, _toDisplayString(_ctx.$t.search), 1),
                _hoisted_12
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_Search)
              ])
            ])
          ])
        ]),
        _createElementVNode("ul", _hoisted_14, [
          _createElementVNode("li", _hoisted_15, [
            _createElementVNode("button", _hoisted_16, _toDisplayString(_ctx.$store.state.firm) + "/" + _toDisplayString(_ctx.$store.state.name), 1),
            _createElementVNode("ul", _hoisted_17, [
              _createVNode(_component_router_link, {
                to: "/account",
                class: "dropdown-item opacity-75"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t.profile), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: "/administration",
                class: "dropdown-item opacity-75"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t.administration), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: "/firm-selection",
                class: "dropdown-item opacity-75"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t.firmSelection), 1)
                ]),
                _: 1
              }),
              (_ctx.checkFirm)
                ? (_openBlock(), _createElementBlock("li", _hoisted_18, _hoisted_20))
                : _createCommentVNode("", true),
              (_ctx.checkFirm)
                ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                    _createElementVNode("button", _hoisted_22, _toDisplayString(_ctx.$t.openReport), 1)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_23,
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  class: "dropdown-item opacity-75",
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logout()))
                }, _toDisplayString(_ctx.$t.logOut), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("h5", _hoisted_28, _toDisplayString(_ctx.$t.report), 1),
                _hoisted_29
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_Datepicker, {
                  class: "d-block w-100",
                  "onUpdate:modelValue": _ctx.openReport,
                  range: "",
                  "enable-time-picker": false,
                  "auto-apply": "",
                  inline: ""
                }, null, 8, ["onUpdate:modelValue"])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}